'use strict';

import ActionTypes from '../constants/ActionTypes';
import AppDispatcher from '../AppDispatcher';
import RouterStore from '../stores/RouterStore';
import UserStore from '../stores/UserStore';
import StampStore from '../stores/StampStore';
import NotificationActionCreators from '../actions/NotificationActionCreators';
import NotificationMessages from '../constants/NotificationMessages';
import AlertActionCreators from '../actions/AlertActionCreators';
import AlertTypes from '../constants/AlertTypes';
import { replaceWith, makeHref } from '../router';
import getStampSegment from '../utils/getStampSegment';
import parseStampSegment from '../utils/parseStampSegment';
import SidebarActionCreators from './SidebarActionCreators';

const StampServerActionCreators = {
  handleStamp(err, response, stampSegment) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.REQUEST_STAMP_ERROR : ActionTypes.REQUEST_STAMP_SUCCESS,
      response: response,
      stampSegment: stampSegment
    });

    if (err) {
      console.error(err);

      var params = RouterStore.getRouterState().params;
      if (err.status === 404 && params.stampSegment === stampSegment) {
        AlertActionCreators.showAlert(AlertTypes.NOT_FOUND);
      }
    }
  },

  handleDeleteStamp(err, response, stampSegment) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.DELETE_STAMP_ERROR : ActionTypes.DELETE_STAMP_SUCCESS,
      response: response,
      stampSegment: stampSegment
    });

    if (err) {
      console.error(err);
    } else {
      // Bail out of reconciling changes
      window.location = makeHref('user', {
        userId: UserStore.getMe().id
      });
    }
  },

  handlePostStamp(err, response) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.POST_STAMP_ERROR : ActionTypes.POST_STAMP_SUCCESS,
      response: response,
      stampId: err ? null : response.result
    });

    if (err) {
      console.error(err);
      AlertActionCreators.showAlert(err.status ? AlertTypes.SERVER_ERROR : AlertTypes.CONNECTION_ERROR);
    } else {
      const stamp = StampStore.get(response.result);
      replaceWith('userLatestStamp', Object.assign({
        userId: UserStore.getMe().id,
        stampSegment: getStampSegment(stamp)
      }));

      window.setTimeout(function () {
        AlertActionCreators.showAlert(AlertTypes.SHARE_POSTED_STAMP, {
          stampId: response.result
        });
      }, 500);
    }
  },

  handleUpdateStamp(err, response, stampSegment) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.UPDATE_STAMP_ERROR : ActionTypes.UPDATE_STAMP_SUCCESS,
      response: response,
      stampSegment: stampSegment
    });

    if (err) {
      console.error(err);
      AlertActionCreators.showAlert(err.status ? AlertTypes.SERVER_ERROR : AlertTypes.CONNECTION_ERROR);
    } else {
      const { stampId } = parseStampSegment(stampSegment);
      const newStampSegment = getStampSegment(StampStore.get(stampId));

      replaceWith('userLatestStamp', {
        userId: UserStore.getMe().id,
        stampSegment: newStampSegment
      });

      NotificationActionCreators.showNotification(NotificationMessages.STAMP_HAS_BEEN_SAVED, { stampId: stampId });
    }
  },

  handleLikeStamp(err, response, stampSegment) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.LIKE_STAMP_ERROR : ActionTypes.LIKE_STAMP_SUCCESS,
      response: response,
      stampSegment: stampSegment
    });

    if (err) {
      console.error(err);
    }
  },

  handleUnlikeStamp(err, response, stampSegment) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.UNLIKE_STAMP_ERROR : ActionTypes.UNLIKE_STAMP_SUCCESS,
      response: response,
      stampSegment: stampSegment
    });

    if (err) {
      console.error(err);
    }
  },

  handleAboutPage(err, response) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.REQUEST_ABOUT_STAMPS_ERROR : ActionTypes.REQUEST_ABOUT_STAMPS_SUCCESS,
      response: response
    });

    if (err) {
      console.error(err);
    }
  },

  handleFeedPage(err, response) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.REQUEST_FEED_ERROR : ActionTypes.REQUEST_FEED_SUCCESS,
      response: response
    });

    if (err) {
      console.error(err);
    }
  },

  handleTrendingPage(err, response) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.REQUEST_TRENDING_STAMPS_ERROR : ActionTypes.REQUEST_TRENDING_STAMPS_SUCCESS,
      response: response
    });

    if (err) {
      console.error(err);
    }
  },

  handleUserLatestPage(err, response, userId) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.REQUEST_USER_LATEST_STAMPS_ERROR : ActionTypes.REQUEST_USER_LATEST_STAMPS_SUCCESS,
      userId: userId,
      response: response
    });

    if (err) {
      console.error(err);
    }
  },

  handleUserLikedPage(err, response, userId) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.REQUEST_USER_LIKED_STAMPS_ERROR : ActionTypes.REQUEST_USER_LIKED_STAMPS_SUCCESS,
      userId: userId,
      response: response
    });

    if (err) {
      console.error(err);
    }
  },

  handleZineLatestPage(err, response, zineSlug) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.REQUEST_ZINE_LATEST_STAMPS_ERROR : ActionTypes.REQUEST_ZINE_LATEST_STAMPS_SUCCESS,
      zineSlug: zineSlug,
      response: response
    });

    if (err) {
      console.error(err);
    }
  },

  handleZinePendingPage(err, response, zineSlug) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.REQUEST_ZINE_PENDING_STAMPS_ERROR : ActionTypes.REQUEST_ZINE_PENDING_STAMPS_SUCCESS,
      zineSlug: zineSlug,
      response: response
    });

    if (err) {
      console.error(err);
    }
  },

  handleStampLikePage(err, response, stampSegment) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.REQUEST_STAMP_LIKES_ERROR : ActionTypes.REQUEST_STAMP_LIKES_SUCCESS,
      stampSegment: stampSegment,
      response: response
    });

    if (err) {
      console.error(err);
    }
  },

  handleSearchPage(err, response, terms) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.REQUEST_STAMP_SEARCH_ERROR : ActionTypes.REQUEST_STAMP_SEARCH_SUCCESS,
      terms: terms,
      response: response
    });

    if (err) {
      console.error(err);
    }
  }
};

export default StampServerActionCreators;


/** WEBPACK FOOTER **
 ** ./actions/StampServerActionCreators.js
 **/